import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

function formatMoney(val) {
  if (Number.isInteger(val)) return String(val);
  return String(val.toFixed(2)).replace(".", ",");
}

export function generateTask() {
  const priceNum = Math.floor(Math.random() * 17) + 4; // 4..20
  const pricePerUnit = priceNum / 2; // krok 0.5

  const x1 = Math.floor(Math.random() * 6) + 2; // 2..7
  let x2 = Math.floor(Math.random() * 9) + 8; // 8..16
  if (x2 === x1) x2 += 1;

  const y1 = pricePerUnit * x1;
  const y2 = pricePerUnit * x2;

  return {
    type: "LinearTextDirectProportionTask",
    data: { x1, x2, y1, y2, pricePerUnit },
    answer: y2,
  };
}

export function renderTask({ data }) {
  const { x1, x2, y1 } = data;
  return (
    <>
      <p>
        W sklepie papierniczym cena notatnikow jest stala i opisana proporcjonalnoscia
        prosta.
      </p>
      <p>
        Za <InlineMath math={`${x1}`} /> sztuk placisz{" "}
        <InlineMath math={`${formatMoney(y1)}`} /> zl.
      </p>
      <p>
        Ile zaplacisz za <InlineMath math={`${x2}`} /> sztuk?
      </p>
    </>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span>
        <InlineMath math={"\\text{koszt}="} />
      </span>
      <FractionInput
        value={userAnswer || ""}
        onChange={onChange}
        disabled={disabled}
        label={"\\text{koszt}"}
        suffixLatex={String.raw`\text{zl}`}
        compactPreview={true}
      />
    </div>
  );
}

export function checkAnswer(task, userAnswer) {
  const parsed =
    typeof userAnswer === "object" && userAnswer !== null
      ? userAnswer.parsed
      : Number(userAnswer);

  if (parsed == null || Number.isNaN(parsed)) return false;
  return Math.abs(parsed - task.answer) < 0.01;
}

export function renderAnswer({ answer }) {
  return <InlineMath math={`\\text{koszt}=${formatMoney(answer)}\\ \\text{zl}`} />;
}

export function renderExplanation({ data }) {
  const { x1, x2, y1, pricePerUnit, y2 } = data;
  return (
    <div className="space-y-3">
      <p>
        <b>Krok 1:</b> Modelujemy sytuacje proporcjonalnoscia prosta{" "}
        <InlineMath math={"f(x)=ax"} />.
      </p>
      <p>
        <b>Krok 2:</b> Wyznaczamy wspolczynnik:
      </p>
      <BlockMath math={`a=\\frac{${formatMoney(y1)}}{${x1}}=${formatMoney(pricePerUnit)}`} />
      <p>
        <b>Krok 3:</b> Liczymy koszt dla <InlineMath math={`x=${x2}`} />:
      </p>
      <BlockMath math={`f(${x2})=${formatMoney(pricePerUnit)}\\cdot ${x2}=${formatMoney(y2)}`} />
      <BlockMath math={`\\text{Odpowiedz: }${formatMoney(y2)}\\ \\text{zl}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer) return <i>(brak odpowiedzi)</i>;
  const raw =
    typeof userAnswer === "object" && userAnswer !== null
      ? userAnswer.raw
      : userAnswer;
  if (!raw && raw !== 0) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`\\text{koszt}=${String(raw)}\\ \\text{zl}`} />;
}
